import { type ObjectValuesUnionType } from '../../../utils/typing';

import { BoomStepId } from './steps';

export const BoomNotificationsTypes = Object.freeze({
  STEP_COMPLETED: 'STEP_COMPLETED',
});

export type BoomNotificationsType = ObjectValuesUnionType<typeof BoomNotificationsTypes>;

export type BoomNotificationState = {
  type: BoomNotificationsType;
  uuid: string;
  data: {
    stepId: BoomStepId;
    amount?: number;
  };
};
